import {DataTableCell, Table, TableBody, TableCell, TableHeader,} from "@david.kucsai/react-pdf-table";
import {Page, Text, View, Document, StyleSheet, PDFViewer, Font, Image} from '@react-pdf/renderer'; // Dit is de PDF generator library
import RobotoRegular from "../assets/fonts/Roboto-Regular.ttf"
import RobotoBold from "../assets/fonts/Roboto-Bold.ttf"
import RobotoItalic from "../assets/fonts/Roboto-Italic.ttf"
import RobotoBoldItalic from "../assets/fonts/Roboto-BoldItalic.ttf"
import {useContext, useEffect} from "react";
import ProjectContext from "../utils/context";
import moment from "moment";
import {euroFormat} from "../utils/usefullFunctions";
import Logo from "../assets/img/nordomatic_logo.png"
import TableListContent from "../components/tabs/preface/TableListContent";
import {useNavigate} from "react-router-dom";
import NotyfApi from "../utils/notyfApi";

// PDF generator
const Print = () => {
    const {project} = useContext(ProjectContext)
    let navigate = useNavigate();


    const selectedOptions = project.service_form_project_options.filter(o => o.value === true).map((o, i) => {
        o.id = i
        return o
    })

    useEffect(() => {

        console.log("project:");
        console.log(project);

        // Geen voorbrief dan naar voorbrief
        if (!project.service_form_project_preface) {
            navigate(`/${project.service_form_id}/preface`)
            NotyfApi.error("Je moet de voorbrief eerst opslaan")
        }
        // Geen calculatie dan naar overzicht
        if (!project.service_form_project_total_sums) {
            navigate(`/${project.service_form_id}/overview`)
            NotyfApi.error("Je moet de calculatie eerst opslaan")
        }
    }, [project])

    if (!project.service_form_project_preface || !project.service_form_project_total_sums) return <></>
    return (<div className={"h-100 justify-content-center d-flex"}>

        <PDFViewer style={styles.viewer}>

            <Document title={"s-tool"}>
                <Page style={styles.body}>
                    {/*Header*/}
                    <View fixed style={styles.topper}>
                        <View style={styles.topperCell}><Image style={styles.yconLogo} src={Logo}/></View>
                        <View style={styles.topperCell}><Text>Onderhoudsofferte</Text></View>
                        <View style={{...styles.topperCell, textAlign: "right"}}>
                            <Text>Projectnummer : {project.service_form_project_reference}</Text>
                            <Text>Datum : {moment().format("DD-MM-YYYY")}</Text>
                            <Text render={({pageNumber, totalPages}) => (
                                `${pageNumber} van ${totalPages} pagina’s`
                            )}/>
                        </View>
                    </View>
                    {/*Pagina 1*/}
                    <View style={{marginBottom: 10}}>
                        <Text style={styles.header} bookmark="Onderhoud">Onderhoud {project.service_form_project_name}</Text>
                        <Text>{project.service_form_project_preface["Opening"]}</Text>
                    </View>
                    <Table style={styles.tableStyle} data={[{
                        service_form_project_building: project.service_form_project_building,
                        service_form_project_ebs: project.service_form_project_ebs,
                        service_form_project_supplier: project.service_form_project_supplier === "div" ? project.service_form_project_supplier_div : project.service_form_project_supplier,
                        service_form_project_nar: project.service_form_project_nar || 0,
                    }]}>
                        <TableHeader style={styles.tableStyle}>
                            <TableCell style={styles.tableStyleHeader}>
                                {project.service_form_project_building > 1 ? "Gebouwen" : "Gebouw"}
                            </TableCell>
                            {project.service_form_project_ebs >= 1 && <TableCell style={styles.tableStyleHeader}>
                                Aantal regelkasten
                            </TableCell>}
                            <TableCell style={styles.tableStyleHeader}>
                                Fabricaat
                            </TableCell>
                            {project.service_form_project_nar ? <TableCell style={styles.tableStyleHeader}>
                                Naregelingen
                            </TableCell> : null}
                        </TableHeader>
                        <TableBody>
                            <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.service_form_project_building}/>
                            {project.service_form_project_ebs >= 1 && <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.service_form_project_ebs}/>}
                            <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.service_form_project_supplier}/>
                            {project.service_form_project_nar ? <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.service_form_project_nar}/> : null}
                        </TableBody>
                    </Table>

                    <View style={{marginVertical: 5}}>
                        <TableListContent data={project.service_form_project_preface["Opening vervolg"]}/>
                    </View>
                    <View style={{marginTop: 10}}>
                        <Text style={styles.textBold}>{project.service_form_project_seller}</Text>
                        <Text> {project.service_form_project_preface["Verkoper gegevens"]}</Text>
                    </View>

                    {/*Pagina 2*/}
                    <View break style={{marginBottom: 10}}>
                        <Text style={styles.header} bookmark="Algemene gegevens">Algemene gegevens</Text>
                        <Text style={{...styles.textBold, textDecoration: "underline"}}>Opdrachtgever / Factuuradres</Text>
                        <View style={{flexDirection: "column", width: 400, marginVertical: 10}}>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Naam</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{project.service_form_project_account_name}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Contactpersoon</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{`${project.service_form_project_firstname} ${project.service_form_project_surname_prefix || ""} ${project.service_form_project_lastname}`}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Adres</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{`${project.service_form_project_street} ${project.service_form_project_street_nr || ""}`}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Postcode/plaats</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{`${project.service_form_project_postal_code}, ${project.service_form_project_city}`}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Telefoonnummer</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{project.service_form_project_account_phone_nr}</Text>
                            </View>
                        </View>

                        <Text style={{...styles.textBold, textDecoration: "underline"}}>Onderhoudslocatie</Text>
                        <View style={{flexDirection: "column", width: 400, marginVertical: 10}}>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Naam</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{project.service_form_project_account_name}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Contactpersoon</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{`${project.service_form_project_firstname} ${project.service_form_project_surname_prefix || ""} ${project.service_form_project_lastname}`}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Adres</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{project.service_form_project_building_address}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Postcode/plaats</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{project.service_form_project_building_zipcode}</Text>
                            </View>
                            <View style={{flexDirection: "row", marginBottom: 10}}>
                                <Text style={{width: 80}}>Telefoonnummer</Text>
                                <Text style={styles.unorderdListBullet}>:</Text>
                                <Text>{project.service_form_project_account_phone_nr}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={{marginBottom: 10}}>
                        <Text style={styles.header} bookmark="Onderhoudsmatrix">Onderhoudsmatrix</Text>

                        <Table style={styles.tableStyle} data={[
                            {
                                text: "Preventief beheer op afstand",
                                value: project.service_form_project_options[0].value ? "Ja" : "Nee",
                            },
                            {
                                text: "Onderhoud regelapparatuur",
                                value: project.service_form_project_options[1].value ? "Ja" : "Nee",
                            },
                            {
                                text: "Onderhoud veldapparatuur",
                                value: project.service_form_project_options[2].value ? "Ja" : "Nee",
                            },
                            {
                                text: "Storingsafhandeling tijdens kantooruren – voorrang",
                                value: project.service_form_project_options[3].value ? "Ja" : "Nee",
                            },
                            {
                                text: "Aanvulling storingsafhandeling 24/7 – telefonisch beschikbaarheid technicus",
                                value: project.service_form_project_options[4].value ? "Ja" : "Nee",
                            },
                            {
                                text: "Onderhoudsrapportage",
                                value: "Jaarlijks",
                            },
                            {
                                text: "Cloud service",
                                value: project.service_form_project_options[5].value ? "Ja" : "Nee",
                            },
                            {
                                text: "GBS service",
                                value: project.service_form_project_options[6].value ? "Ja" : "Nee",
                            },
                            {
                                text: "Energie monitoring – incl rapportage",
                                value: project.service_form_project_options[8].value ? "Jaarlijks" : "Nee",
                            },
                            {
                                text: "Ongeplande reparaties en bezoeken",
                                value: "Op regie",
                            },
                        ]}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader} weighting={0.8}>
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader} weighting={0.2}>
                                    Inclusief
                                </TableCell>
                            </TableHeader>
                            <TableBody>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.text} weighting={0.8}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.value} weighting={0.2}/>
                            </TableBody>
                        </Table>
                    </View>

                    {/*Pagina 3*/}
                    <View break style={{marginBottom: 15}}>
                        <Text style={styles.header} bookmark="Prijs offerte">Prijs offerte</Text>
                        <Table style={styles.tableStyle} data={selectedOptions}>
                            <TableHeader style={styles.tableStyle}>
                                <TableCell style={styles.tableStyleHeader} weighting={0.15}>
                                    Pos
                                </TableCell>
                                <TableCell style={styles.tableStyleHeader} weighting={0.85}>
                                    Onderdeel
                                </TableCell>
                            </TableHeader>
                            <TableBody style={styles.tableStyle}>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => "Pos " + (r.id + 1)} weighting={0.15}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.label} weighting={0.85}/>
                            </TableBody>
                        </Table>
                    </View>
                    <View style={{marginBottom: 20}}>
                        <Text style={{...styles.textBold, marginBottom: 10}}>Prijs</Text>
                        <View style={{flexDirection: "row", justifyContent: "space-between"}}>
                            <Text>De totaalprijs voor een jaarcontract excl BTW bedraagt:</Text>
                            <Text>{euroFormat(project.service_form_project_total_sums.sale)}</Text>
                        </View>
                    </View>
                    <View style={{marginBottom: 20}}>
                        <Text style={{...styles.textBold, marginBottom: 10}}>Facturatie</Text>
                        <Text>{project.service_form_project_preface["Facturatie"]}</Text>
                    </View>
                    <View style={{marginBottom: 20}}>
                        <Text style={{...styles.textBold, marginBottom: 10}}>Betalingscondities</Text>
                        <Text>{project.service_form_project_preface["Betalingscondities"]}</Text>
                    </View>
                    {/*Pagina 4 Inhoudsopgave*/}
                    {/*<View break>*/}
                    {/*    <Text style={styles.header}>Inhoudsopgave</Text>*/}

                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Onderhoud {project.service_form_project_name} PROJECT</Text>*/}
                    {/*        <Text>1</Text>*/}
                    {/*    </View>*/}
                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Algemene gegevens</Text>*/}
                    {/*        <Text>2</Text>*/}
                    {/*    </View>*/}
                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Onderhoudsmatrix</Text>*/}
                    {/*        <Text>2</Text>*/}
                    {/*    </View>*/}
                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Prijs offerte</Text>*/}
                    {/*        <Text>3</Text>*/}
                    {/*    </View>*/}
                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Inhoudsopgave</Text>*/}
                    {/*        <Text>4</Text>*/}
                    {/*    </View>*/}
                    {/*    {selectedOptions.map(o => <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text> {o.id + 1} {o.label}</Text>*/}
                    {/*    </View>)}*/}

                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Belangrijke uitgangspunten</Text>*/}
                    {/*    </View>*/}
                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Uitsluiting</Text>*/}
                    {/*    </View>*/}
                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Aansprakelijkheid</Text>*/}
                    {/*    </View>*/}
                    {/*    <View style={{flexDirection: "row", justifyContent: "space-between", marginBottom: 5, fontStyle: "italic-bold"}}>*/}
                    {/*        <Text>Algemene condities</Text>*/}
                    {/*    </View>*/}
                    {/*</View>*/}

                    {/* Preventief beheer op afstand */}
                    {project.service_form_project_options[0].value && <View break>
                        <Text style={styles.header} bookmark="Preventief beheer op afstand">Preventief beheer op afstand</Text>
                        <TableListContent data={project.service_form_project_preface["Preventief beheer op afstand"]}/>
                    </View>
                    }

                    {/* Onderhoud regelapparatuur, netwerk en GBS */}
                    {project.service_form_project_options[1].value && <View break>
                        <Text style={styles.header} bookmark="Onderhoud regelapparatuur, netwerk en GBS">Onderhoud regelapparatuur, netwerk en GBS</Text>
                        <TableListContent data={project.service_form_project_preface["Onderhoud regelapparatuur"]}/>

                    </View>}

                    {/* Onderhoud regelkast en veldapparatuur */}
                    {project.service_form_project_options[2].value && <View break>
                        <Text style={styles.header} bookmark="Onderhoud regelkast en veldapparatuur">Onderhoud regelkast en veldapparatuur</Text>
                        <TableListContent data={project.service_form_project_preface["Onderhoud regelkast"]}/>

                    </View>
                    }

                    {/* Storingsafhandeling tijdens kantooruren*/}
                    {project.service_form_project_options[3].value && <View break>
                        <Text style={styles.header} bookmark="Storingsafhandeling">Storingsafhandeling tijdens kantooruren</Text>
                        <TableListContent data={project.service_form_project_preface["Storingsafhandeling tijdens kantooruren"]}/>

                        {project.service_form_project_options[4].value && <View style={{marginTop: 20}}>
                            <Text style={styles.header}>Aanvulling storingsafhandeling 24/7</Text>
                            <Text> {project.service_form_project_preface["Aanvulling storingsafhandeling 24/7"]}</Text>
                        </View>
                        }
                    </View>}

                    {/* Cloud Service*/}
                    {project.service_form_project_options[5].value && <View break>
                        <Text style={styles.header} bookmark="Cloud Service">Cloud Service</Text>
                        <TableListContent data={project.service_form_project_preface["Cloud Service"]}/>
                    </View>}

                    {/*GBS Service*/}
                    {project.service_form_project_options[6].value && <View break>
                        <Text style={styles.header} bookmark="GBS Service">GBS Service</Text>
                        <Text style={{marginBottom: 20}}>{project.service_form_project_preface["GBS Service"]}</Text>

                        {project.service_form_project_options[8].value && <View><Text bookmark="Energie Monitoring" style={styles.header}>Energie Monitoring</Text>

                            <Text style={{marginBottom: 10}}>{project.service_form_project_preface["Energie Monitoring"]}</Text>
                        </View>}
                    </View>}


                    {/*Belangrijke uitgangspunten*/}
                    <View break>
                        <Text style={styles.header} bookmark="Belangrijke uitgangspunten">Belangrijke uitgangspunten</Text>
                        <TableListContent data={project.service_form_project_preface["Belangrijke uitgangspunten"]}/>
                    </View>

                    <View break>
                        <Text style={styles.header} bookmark="Uitsluitingen">Uitsluitingen</Text>
                        <TableListContent data={project.service_form_project_preface["Uitsluitingen"]}/>

                        <Text style={styles.header}>Aansprakelijkheid</Text>
                        <TableListContent data={project.service_form_project_preface["Aansprakelijkheid"]}/>
                    </View>

                    <View break>
                        <Text style={styles.header} bookmark="Algemene condities">Algemene condities</Text>
                        <TableListContent data={project.service_form_project_preface["Algemene condities"]}/>

                    </View>

                    {project.service_form_project_data_product.filter(d => d.amount).length ? <View break>
                        <Text style={styles.header} bookmark="Artikelen">Artikelen</Text>
                        <Table style={styles.tableStyle} data={project.service_form_project_data_product.filter(d => d.amount)}>
                            <TableHeader style={styles.tableStyle} includeTopBorder={false} includeRightBorder={false} includeLeftBorder={false} textAlign={"center"}>
                                <TableCell style={styles.headerNumber} weighting={0.05}>
                                    #
                                </TableCell>
                                <TableCell style={styles.headerText} weighting={0.25}>
                                    Artikelnummer
                                </TableCell>
                                <TableCell style={styles.headerText} weighting={0.45}>
                                    Omschrijving
                                </TableCell>
                                <TableCell style={styles.headerText} weighting={0.25}>
                                    Toelichting
                                </TableCell>
                            </TableHeader>
                            <TableBody includeTopBorder={false} includeRightBorder={false} includeLeftBorder={false} includeBottomBorder={false} fontSize={9}>
                                <DataTableCell style={styles.cellNumberAmount} getContent={(r) => r.amount || ""} weighting={0.05}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.article || ""} weighting={0.25}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.article_description || ""} weighting={0.45}/>
                                <DataTableCell style={styles.tableStyleCell} getContent={(r) => r.row_description || ""} weighting={0.25}/>
                            </TableBody>
                        </Table>
                    </View> : null}

                </Page>
            </Document>
        </PDFViewer>
    </div>)
}

export default Print

Font.register({
    family: 'Roboto', fonts: [
        {src: RobotoRegular}, // font-style: normal, font-weight: normal
        {src: RobotoItalic, fontStyle: 'italic'},
        {src: RobotoBoldItalic, fontStyle: 'italic-bold'},
        {src: RobotoBold, fontStyle: 'bold'},
    ]
});

// Removes hyphenation (-) <= dit ding
Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create(
    {
        h1: {
            fontSize: 22,
            fontFamily: "Roboto",
            fontStyle: "bold",
            margin: 0,
            padding: 0,
        },
        h2: {
            fontSize: 18,
            fontFamily: "Roboto",
            fontStyle: "bold",
            margin: 0,
            padding: 0,
        },
        h3: {
            fontSize: 14,
            fontFamily: "Roboto",
            fontStyle: "bold",
            margin: 0,
            padding: 0,
        },
        p: {
            // fontFamily: 'Roboto',
            fontSize: 10,
            margin: 0,
            justifyContent: "start",


        },
        strong: {
            fontFamily: "Roboto",
            fontStyle: "bold",
        },
        em: {
            fontFamily: "Roboto",
            fontStyle: "italic",
        },
        ol: {
            fontSize: 10
        },
        ul: {
            fontSize: 10
        },
        img: {
            width: 370,
            height: 300,
            margin: 0,
            padding: 0,
        },
        cellNumberAmount: {
            textAlign: 'center',
            fontFamily: 'Roboto',
            justifyContent: "start",
            paddingTop: 5,
        },
        header: {
            fontSize: 18,
            fontFamily: "Roboto",
            fontStyle: "bold",
            textDecoration: "underline",
            marginBottom: 15
        },
        headerNumber: {
            paddingVertical: 5,
            backgroundColor: '#eaeaea',
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 11
        },
        headerText: {
            padding: 5,
            backgroundColor: '#eaeaea',
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 11

        },
        headerTable: {
            fontSize: 14,
            fontFamily: "Roboto",
            fontStyle: "bold",
            marginBottom: 20
        },
        tableStyle: {
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start",
            marginBottom: 20,
        },
        tableStyleCell: {
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start",
            padding: 5,
        },
        tableStyleCellHeader: {
            fontSize: 16,
            justifyContent: "start",
            padding: 5,
        },
        tableStyleHeader: {
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start",
            padding: 5,
        },
        tableStyleGeneral: {
            border: 0,
            // fontFamily: "Roboto",
            fontSize: 10,
            justifyContent: "start"
        },
        tableStyleGeneralHeader: {
            border: 0,

            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 12,
            justifyContent: "start"
        },
        textInfo: {
            fontSize: 9,
            fontFamily: "Roboto",
            lineHeight: 1.3,
            color: '#8B8D8C',
            textAlign: "right"
        },
        textInfoBold: {
            fontSize: 9,
            fontFamily: "Roboto",
            fontStyle: "bold",
            lineHeight: 1.3,
            color: '#8B8D8C',
            textAlign: "right"

        },
        textBold: {

            fontFamily: "Roboto",
            fontStyle: "bold",
        },
        textBoldUnderline: {

            fontFamily: "Roboto",
            fontStyle: "bold",
            textDecoration: "underline"
        },
        title: {
            fontFamily: "Roboto",
            fontStyle: "bold",
            fontSize: 16,
            marginBottom: 10,
        },
        topper: {
            justifyContent: "space-between",
            flexDirection: "row",
            width: "100%",
            marginBottom: 25,
            color: "gray"
        },
        topperCell: {
            padding: 5,
            margin: 0,
        },
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 45,
            fontFamily: 'Roboto',
            fontSize: 11

        },
        viewer: {
            width: "100%",
            height: "calc(100% - 40px)",
        },
        yconInfo: {
            width: 100
        },
        yconLogo: {width: 120, height: "auto"},
        unorderdList: {flexDirection: "row", marginBottom: 4},
        unorderdListBullet: {marginHorizontal: 8},
        unorderdListText: {width: "95%"}


    });

